import { render, staticRenderFns } from "./TreeDropdown.vue?vue&type=template&id=06336f2c&"
import script from "./TreeDropdown.vue?vue&type=script&lang=js&"
export * from "./TreeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports